<template>
  <div>
    <Swiper :datas="swiperData" :opts="''" @events="swiperEvents" />
    <div class="us_main">
      <div class="us_title">
        <img src="@/assets/huodong_dot.png" alt="">
        <span class="ml_05">关于我们</span>
      </div>
      <div class="us_text">
        无悠网络科技有限公司以棋牌游戏为核心，及游戏研发于运营为一体，为广大用户群体提供公平，公正，健康的游戏平台，致力于为所有热爱棋牌游戏的用户提供最好的服务。公司产品囊括全国各地麻将，扑克等多个游戏类型，可以让全国各地热爱棋牌游戏的玩家找到自己喜欢的游戏。公司以公平公正，绿色健康，画面精美，玩法丰富和最好的服务态度赢得广大游戏用户的支持。
      </div>
      <div class="us_text" style="display:none;">
        无悠网络科技有限公司是中国最具发展潜力的游戏公司之一。无悠网络以棋牌游戏为核心业务，集游戏研发运营及发行于一体，致力于为所有喜爱竞技游戏的用户提供优质精彩的棋牌、游戏、娱乐及服务的互联网公司。其中棋牌产品涵盖麻将、扑克等数十款棋牌种类。玩法新、速度快、体验爽、省流量以及卓越的服务质量为无悠网络赢得了更多移动互联网用户。无悠网络也被用户誉为创新、安全、最具价值的游戏品牌。
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Swiper from '@/components/common/Swiper.vue'

export default {
  name: 'UsMobile',
  components: {
    Swiper
  },
  data: () => {
    return {
    }
  },
  methods: {
    // 轮播事件返回
    swiperEvents (vtype, vitem, vid) {
      console.log(vtype, vitem, vid)
    }
  },
  computed: {
    swiperData () {
      return this.$store.state.configs.swiperData
    }
  }
}
</script>
<style scoped>
.us_main {
  background: rgb(246, 247, 251);
  margin: 1rem 0;
  text-align: left;
}
.us_title {
  font-size: 1rem;
  border-bottom: 1px rgba(0, 0, 0, 0.06) solid;
  padding: 0.3rem 1rem;
}
.us_text {
  padding: 2rem;
  text-indent: 1.6rem;
  font-size: 0.6rem;
}
</style>
